import { Controller } from "@hotwired/stimulus"

// Triggers the GPS modal without relying on inline JavaScript.
// Usage:
//   data-controller="gps-trigger"
//   data-gps-trigger-require-verification-value="true"
//   data-gps-trigger-fallback-url-value="/products"
//   data-action="click->gps-trigger#handle"
export default class extends Controller {
  static values = {
    selector: { type: String, default: '[data-controller~="gps"]' },
    requireVerification: { type: Boolean, default: true },
    fallbackUrl: String
  }

  handle(event) {
    if (!this.requireVerificationValue) return

    const overlay = this.findOverlay()

    if (overlay) {
      event.preventDefault()
      overlay.dispatchEvent(new CustomEvent('gps:open', {
        detail: { sourceEvent: event },
        bubbles: false
      }))
      return
    }

    if (this.hasFallbackUrlValue) {
      event.preventDefault()
      window.location.href = this.fallbackUrlValue
    }
  }

  findOverlay() {
    return document.querySelector(this.selectorValue)
  }
}
